/**
 * Copyright (c) 2023-present.
 * This source code is copied from https://github.com/justinmahar/react-social-media-embed
 */
import React from 'react'

export const EmbedStyle = () => {
  return (
    <style>
      {`
        .rsme-embed .rsme-d-none {
          display: none;
        }
    
        .rsme-embed blockquote {
          margin: 0 !important;
          padding: 0 !important;
        }

        .rsme-embed.rsme-facebook-embed .fb-post iframe {
          width: 100% !important;
        }

        .rsme-embed.rsme-facebook-embed .fb-post span {
          width: 100% !important;
        }
      `}
    </style>
  )
}
